import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';

import { DateAngularModule } from 'rev-shared/date/DateAngular.Module';
import { DirectivesAngularModule } from 'rev-shared/util/directives/DirectivesAngular.Module';
import { FormGroupAngularModule } from 'rev-shared/ui/formGroup/FormGroupAngular.Module';
import { TextInputAngularModule } from 'rev-shared/ui/text-input/TextInputAngular.Module';
import { VbUiDatePickerModule } from 'rev-shared/ui/datePicker/VbUiDatePicker.Module';

import { VbDateTimePickerComponent } from './VbDateTimePicker.Component';

const components = [
	VbDateTimePickerComponent
];

@NgModule({
	declarations: components,
	exports: components,
	imports: [
		CommonModule,
		DateAngularModule,
		DirectivesAngularModule,
		FormGroupAngularModule,
		FormsModule,
		ReactiveFormsModule,
		TextInputAngularModule,
		TimepickerModule,
		TranslateModule,
		VbUiDatePickerModule
	]
})
export class VbDateTimePickerModule {}
